import React, { useEffect, useState } from 'react';
import "./createUser.scss";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import GenericForm, { FormField } from '../../../components/GenericForm';
import { createUser } from '../../../common/api/apiCalls';
import { useQuery } from '@tanstack/react-query';
import { useAlert } from '../../../common/contexts/AlertContext';
import { roles } from '../../../common/types/roles';
import { getAllSites } from '../../../common/api/siteService';
import Loader from '../../../components/Loader/Loader';


let initialFields: FormField[] = [
    { label: 'First Name*', name: 'firstName', type: 'text' },
    { label: 'Last Name*', name: 'lastName', type: 'text' },
    { label: 'Email*', name: 'email', type: 'email' },
    { label: 'ID Number*', name: 'idNumber', type: 'text' },
    { label: 'Role*', name: 'role', type: 'select', options: [{ label: roles.Admin, value: roles.Admin }, { label: roles.HCP, value: roles.HCP }] },
    { label: 'Center', name: 'center', type: 'select', options: [], initialValue: "" },
    // { label: 'Receive Notifications', name: 'notifications', type: 'switch', value: false }
];

const CreateUser = () => {
    const [fields, setFields] = useState<FormField[]>(initialFields);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const alert = useAlert();


    const { isLoading, error, data } = useQuery({
        queryKey: ['centerData'],
        queryFn: getAllSites
    });

    const getText = (text: string) => t(`CreateUser.${text}`);

    const handleSubmit = async (formData: { [key: string]: any }) => {
        console.log('Form submitted with data:', formData);

        const res = await createUser({
            username: formData.email,
            firstName: formData.firstName,
            lastName: formData.lastName,
            identityNumber: formData.idNumber,
            role: formData.role,
            site: formData.center,
            phoneNumber: formData.phoneNumber,
        })        
        if (res.success) {
            alert(t("general.success.userCreated"), "msg");
            navigate(-1)
        }
        else{
            alert(t(res.data?.errorMessage || "general.errors.generalError"), "error");
        }

        // Handle the form submission logic here, such as calling createUser API
    };

    useEffect(() => {
        if (Array.isArray(data)) {
            const updatedFields = fields.map(field => {
                if (field.name === 'center') {
                    return {
                        ...field,
                        options: data
                            .filter((site: any) => site && site.SiteName) // Ensure site and SiteName exist
                            .map((site: any) => ({ label: site.SiteName, value: site.SiteName }))
                    };
                }
                return field;
            });
            setFields(updatedFields);
        }
    }, [data]);

    if (isLoading) {
       return <Loader text={getText("Loading...")} />;
    }

    if (error) {
        return <div>{getText("Error fetching centers")}</div>;
    }

    return (
        <>
            <GenericForm
                backButtonAction={() => navigate(-1)}
                backButtonText={getText("Back")}
                buttonText={getText("Save_changes")}
                fields={fields}
                onSubmit={handleSubmit}
                title={getText("create_user")}
            />
        </>
    );
};

export default CreateUser;
